<template>
  <div class="bg-gradient-primary">
    <div class="container">
      <div class="row align-items-center" style="height: 100vh">
        <div class="col-md-6 offset-md-3">
          <div class="text-center">
            <img src="../assets/logo_fencom_horizontal_negativo.png" class="img-fluid"/>
          </div>
          <br/>
          <div class="card shadow">
            <div class="card-body">
              <div class="alert alert-warning" role="alert" v-show="showErrors">
                <div v-for="(erro, i) in erros" v-bind:key="i" class="text-center">{{erro}}</div>
              </div>
              <div class="alert alert-danger" role="alert" v-show="showErrorsDanger">
                <div v-for="(erro, i) in errosDanger" v-bind:key="i" class="text-center">{{erro}}</div>
              </div>
              <br />
              <div class="row">
                <div class="col-md-6 offset-md-3">
                  <div class="form-group">
                    <label class="col-form-label-sm label-input" for="usuario">Usuário:</label>
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      id="usuario"
                      v-model.trim="input.usuario"
                    />
                  </div>
                </div>
                <div class="col-md-6 offset-md-3">
                  <div class="form-group">
                    <label class="col-form-label-sm label-input" for="senha">Senha:</label>
                    <input
                      type="password"
                      class="form-control form-control-sm"
                      id="senha"
                      v-model.trim="input.senha"
                    />
                  </div>
                </div>
              </div>
              <br />
              <br />
              <div class="row">
                <div class="col-md-6 offset-md-3">
                  <div class="form-group">
                    <button
                      class="btn btn-block btn-primary"
                      :disabled="carregando || input.usuario == '' || input.senha == ''"
                      @click="realizarLogin()"
                    >
                      <div v-if="carregando">
                        <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                        Carregando...
                      </div>
                      <div v-else>Entrar</div>
                    </button>
                  </div>
                </div>
              </div>
            </div>



          </div>
        </div>
      </div>
    </div>
    
            
            <modal v-show="isModalVisible" @close="closeModal">
              <span slot="header">Termo de Responsabilidade</span>
              <div slot="body" v-html="input.termoResponsabilidade.texto">
              </div>
              <div slot="footer">

                <button class="btn btn-danger" @click="closeModal()">
                  <li class="oi oi-circle-x"></li> Não Aceito
                </button>
                <button class="btn btn-secondary" @click="salvarTermoResponsabilidade()" :disabled="disabledSalvarTermo">
                  <li class="oi oi-check"></li> Aceitar e Prosseguir
                </button>
              </div>
            </modal>
  </div>
  
</template>

<script>
import http from "../axios";
import crypto from "crypto";
import moment from "moment"
import modal from "./utils/Modal";
moment.locale('pt-BR');
export default {
  name: "Login",
  components: { modal: modal },
  data() {
    return {
      input: {
        usuario: "",
        senha: "",
        termoResponsabilidade: "",
        liEaceitei: false
      },
      isModalVisible: false,
      carregando: false,
      disabledSalvarTermo: false,
      showErrors: false,
      erros: [],
      showErrorsDanger: false,
      errosDanger: [],
      tokens: {}
    };
  },
  methods: {
    showModal() {
      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
    },  
       
    getTermoResponsabilidade: function() {
      http
        .get(`api/cooperado/termoresponsabilidade/naoaceito/${this.tokens.id}`, {
          headers: { "token-cooperado-api": this.tokens.token }
        })
        .then(r => {
          if (r.data.statusCode == 200) {
            this.input.termoResponsabilidade = r.data.result[0];
            this.showModal();
          }
        })
        .catch(error => {
          if (error.response) {
            if (error.response.status >= 500) {
              this.$router.push("/");
            }else{
              if (error.response.status == 400) {
                this.$router.push("/DeclaracaoInssLista");
              }
            }
          } else if (error.request) {
            this.$router.push("/");
          } else {
            console.log("Error", error.message);
            this.$router.push("/");
          }
        });
    },
    salvarTermoResponsabilidade: function() {
      this.disabledSalvarTermo = true;
      this.$Progress.start();
      if (!this.showErrors) {
        var objeto = {
          termo: this.input.termoResponsabilidade.id,
          cooperado: this.tokens.id
        };
        http
          .post(`api/cooperado/termoresponsabilidade/aceitar/insert`, objeto, {
            headers: { "token-cooperado-api": this.tokens.token }
          })
          .then(r => {
            if (r.data.statusCode == 200) {
              this.$router.push("/DeclaracaoInssLista");
              this.$Progress.finish();
            }
          })
          .catch(error => {
            console.log(error);
            this.$Progress.fail();
            this.disabledSalvarTermo = false;
            if (error.response) {
              if (error.response.status >= 500) {
                this.$router.push("/");
              } else {
                if (error.response.status == 400) {
                  for (var i in error.response.data.result) {
                    this.erros.push(error.response.data.result[i]);
                  }
                  if (this.erros.length > 0) {
                    this.showErrors = true;
                  }
                }
              }
            } else if (error.request) {
              this.$router.push("/");
            } else {
              console.log("Error", error.message);
              this.$router.push("/");
            }
          });
      } else {
        this.$Progress.fail();
      }
    },

    verificaSessao: function(){
      this.showErrorsDanger = false,
      this.errosDanger = []
      var expiresIn =  this.$cooperadowebapi.tokens != undefined  && this.$cooperadowebapi.tokens.get("usuario") != undefined && this.$cooperadowebapi.tokens.get("usuario").expiresIn != undefined ? this.$cooperadowebapi.tokens.get("usuario").expiresIn : undefined
      if(expiresIn != undefined && expiresIn > 0){
        var x = new moment();
        var y = new moment(expiresIn)
        var duration = moment.duration(y.diff(x));
        if(parseInt(duration.get('minutes')) <= 0 && parseInt(duration.get('seconds')) <= 0){
          this.showErrorsDanger = true,
          this.errosDanger.push("Sessão expirada! Entre novamente!");
        }
      }
    },

    realizarLogin: function() {
      this.erros = [];
      this.showErrors = false;
      this.carregando = true;
      var objeto = {
        usuario: this.input.usuario,
        senha: crypto
          .createHash("md5")
          .update(this.input.senha)
          .digest("hex")
      };
      
      http
        .post("api/usuario/login", objeto)
        .then(r => {
          if (r.data.statusCode == "200") {
            var usuario = r.data.result[0];
            usuario.expiresIn = moment().add(usuario.expiresIn, 'seconds').toDate().getTime();
            this.$cooperadowebapi.tokens.set("usuario", r.data.result[0]);
            this.getTokens();
            this.getTermoResponsabilidade();
          }
          this.carregando = false;
        })
        .catch(error => {
          if (error.response) {
            if (error.response.status >= 500) {
              this.erros.push("Sessão expirada! Tente novamente.");
            }
            if (error.response.status == 400) {
              this.erros.push(error.response.data.result);
            }
          } else if (error.request) {
            this.erros.push(
              "Serviço indisponível temporariamente! Tente novamente mais tarde."
            );
          } else {
            this.erros.push(
              "Serviço indisponível temporariamente! Tente novamente mais tarde."
            );
          }
          this.showErrors = this.erros.length > 0;
          this.carregando = false;
        });
    },
    getTokens: function() {
      this.tokens = this.$cooperadowebapi.tokens.get("usuario");
    }
  },
  created: function() {
    this.getTokens();
    this.verificaSessao();
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Login.vue